import { render, staticRenderFns } from "./MyLaps.vue?vue&type=template&id=2b01bdad"
import script from "./MyLaps.vue?vue&type=script&lang=js"
export * from "./MyLaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports